import React, { Suspense } from "react";
import { useTranslation } from "@hooks/useTranslation";
import PartiesContainer from "../parties";
import Header from "./header";
import { useDocument } from '@EUForms/hooks/useDocument'
import { CustomLoader } from "@commonComponents/formComponents/loader";
import AuthorizationDetail from "../parties/authorizationDetail";
import EconomicOperatorDetail from "../parties/economicOperatorDetail";
import RepeatableContainer from "@containers/repeatableContainer";
import AddtionalSupplyChainDetail from "../parties/addtionalSupplyChainDetail";
const PaymentDetail = React.lazy(() => import("../parties/paymentDetail"))
const GuaranteeDetail = React.lazy(() => import("../parties/guaranteeDetail"))
const AddGuaranteeDetail = React.lazy(() => import("../parties/addGuaranteeDetail"))
import { selectCountryList, selectSupplyChainOwnerList } from "@EUForms/selectors";
import { useSelector } from "react-redux";
import { actorActions } from '../../reducer/actorSlice'
import { useValidateDecByDispatchCntry } from "../../hooks";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const HeaderContainer = (props) => {
  
  const { 
    procedure, 
    isProcI2AorB, 
    shipmentId, 
    jobWheels, 
    kxUser, 
    version,
    serviceType, 
    repeatableValidationMethods, 
    lowerEnv,
    shipId
  } = props
  
  const translate = useTranslation()
  const { addItemParties, updateItemParties, delteItemParties, updatePartiesContactInfo } = actorActions
  const { isLoading, updateContactInfo, ...rest } = useDocument({
    addData: addItemParties,
    updateData: updateItemParties,
    deleteData: delteItemParties,
    updateContact: updatePartiesContactInfo,
    containerKey: 'parties',
  })
  const supplyChainOwnerList = useSelector(selectSupplyChainOwnerList)

  const countryList = useSelector(selectCountryList)
  const { isImportShipment } = useCurrentShipmentType()
  // const response = useValidateDecByDispatchCntry(countryList, isImportShipment)

  const authorizationsList = useSelector((state) => state?.actorReducer?.authorizationsList) || [];
  const displayEconomicOperator = authorizationsList?.some(({ type }) => type === 'C513')

  return (
    <div className="headerDetails formContentareaC88">
      {isLoading && <CustomLoader style={{ position: "fixed" }} />}
      <Header 
        isImportShipment={isImportShipment} 
        version={version} 
        jobWheels={jobWheels} 
        translate={translate} 
        kxUser={kxUser}
        shipmentId={shipmentId}
        serviceType={serviceType}
        lowerEnv={lowerEnv}
        shipId={shipId}
      />
      <PartiesContainer isImportShipment={isImportShipment} countryList={countryList}  {...rest} translate={translate} />

      <RepeatableContainer
        {...rest}
        tableName="authorizationsList"
        reducerName="actorReducer"
        title="Authorization"
        translate={translate}
        renderForm={(params) => <AuthorizationDetail supplyChainOwnerList={supplyChainOwnerList} {...params} />}
      />
      {!isProcI2AorB && <RepeatableContainer
        {...rest}
        tableName="additionalSupplyChainActorsList"
        reducerName="actorReducer"
        title="ADD SUPPLY CHAIN ACTOR"
        boxNumber="3/37"
        translate={translate}
        renderForm={(params) => <AddtionalSupplyChainDetail supplyChainOwnerList={supplyChainOwnerList} isImportShipment={isImportShipment} {...params} />
        }
      />}

      <Suspense fallback={<div>Loading...</div>}>
        {isImportShipment && <RepeatableContainer
          {...rest}
          translate={translate}
          reducerName="actorReducer"
          title="PAYMENT DETAILS"
          tableName="paymentDetails"
          maxRowsAllowed={100}
          hideAddBtn={procedure == "H2" || isProcI2AorB}
          {...repeatableValidationMethods}
          renderForm={(params) => <PaymentDetail   {...params} />
          }
        />}
        {isImportShipment && !isProcI2AorB && <> <RepeatableContainer
          {...rest}
          translate={translate}
          reducerName="actorReducer"
          title={`${translate("GUARANTEE_DETAIL", { ns: ["default", "parties"] })}`}
          tableName="guaranteeDetailList"
          renderForm={(params) => <GuaranteeDetail  {...params} />
          }
        />
          <RepeatableContainer
            {...rest}
            translate={translate}
            reducerName="actorReducer"
            title={`ADD ${translate("GUARANTEE_DETAIL", { ns: ["default", "parties"] })}`}
            tableName="addGuaranteeDetailList"
            renderForm={(params) => <AddGuaranteeDetail  {...params} />
            }
          />
        </>}
      </Suspense>
      {displayEconomicOperator && (
        <RepeatableContainer
          {...rest}
          tableName="economicOperatorsList"
          reducerName="actorReducer"
          title="ECONOMIC_OPERATOR"
          translate={translate}
          maxRowsAllowed={1}
          renderForm={(params) => <EconomicOperatorDetail countryList={countryList} {...params} />}
        />
      )}
    </div>
  );
}

export default React.memo(HeaderContainer)
